var _rect, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyPatients(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 174,
    viewBox: "0 0 212 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 2,
    width: 212,
    height: 172,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.536 57.8999C178.814 57.8999 181.472 60.5951 181.472 63.9199C181.472 67.2447 178.814 69.9399 175.536 69.9399H141.616C144.894 69.9399 147.552 72.6351 147.552 75.9599C147.552 79.2847 144.894 81.9799 141.616 81.9799H160.272C163.55 81.9799 166.208 84.6751 166.208 87.9999C166.208 91.3247 163.55 94.0199 160.272 94.0199H151.644C147.511 94.0199 144.16 96.7151 144.16 100.04C144.16 102.256 145.856 104.263 149.248 106.06C152.526 106.06 155.184 108.755 155.184 112.08C155.184 115.405 152.526 118.1 149.248 118.1H78.864C75.5856 118.1 72.928 115.405 72.928 112.08C72.928 108.755 75.5856 106.06 78.864 106.06H45.792C42.5136 106.06 39.856 103.365 39.856 100.04C39.856 96.7151 42.5136 94.0199 45.792 94.0199H79.712C82.9903 94.0199 85.648 91.3247 85.648 87.9999C85.648 84.6751 82.9903 81.9799 79.712 81.9799H58.512C55.2336 81.9799 52.576 79.2847 52.576 75.9599C52.576 72.6351 55.2336 69.9399 58.512 69.9399H92.432C89.1536 69.9399 86.496 67.2447 86.496 63.9199C86.496 60.5951 89.1536 57.8999 92.432 57.8999H175.536ZM175.536 81.9799C178.814 81.9799 181.472 84.6751 181.472 87.9999C181.472 91.3247 178.814 94.0199 175.536 94.0199C172.258 94.0199 169.6 91.3247 169.6 87.9999C169.6 84.6751 172.258 81.9799 175.536 81.9799Z",
    fill: "#DFE5EB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2118_3900)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75 101C75 95.4772 79.4772 91 85 91H116C120.971 91 125 95.0294 125 100V112H75V101Z",
    fill: "#FFF7DE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 61,
    r: 15,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.126 78.5833C90.591 78.5833 82.834 70.8263 82.834 61.2917C82.834 51.757 90.591 44 100.126 44C109.66 44 117.417 51.757 117.417 61.2917C117.417 70.8263 109.66 78.5833 100.126 78.5833ZM100.126 47.4583C92.4966 47.4583 86.2923 53.6626 86.2923 61.2917C86.2923 68.9207 92.4966 75.125 100.126 75.125C107.755 75.125 113.959 68.9207 113.959 61.2917C113.959 53.6626 107.755 47.4583 100.126 47.4583Z",
    fill: "#88C3E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4996 74.9999C86 65.4999 89.5 53.4999 99.9996 47.4999C95 46.9999 85.9994 50.9999 86 60.9999C86.0006 71.9999 97 75.4999 99.4996 74.9999Z",
    fill: "#E8F7E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4792 116.625H70.7292C69.7747 116.625 69 115.85 69 114.896V101.062C69 92.4824 75.9824 85.5 84.5625 85.5H115.688C119.931 85.5 124.015 87.2465 126.903 90.2932C127.56 90.9849 127.532 92.0812 126.837 92.7383C126.146 93.3988 125.049 93.3677 124.392 92.6726C122.158 90.314 118.983 88.9583 115.688 88.9583H84.5625C77.8879 88.9583 72.4583 94.3879 72.4583 101.062V113.167H91.4792C92.4337 113.167 93.2083 113.941 93.2083 114.896C93.2083 115.85 92.4337 116.625 91.4792 116.625Z",
    fill: "#88C3E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.146 127C118.492 127 117.894 126.634 117.6 126.046L111.161 113.167H101.854C100.9 113.167 100.125 112.392 100.125 111.438C100.125 110.483 100.9 109.708 101.854 109.708H112.229C112.883 109.708 113.481 110.079 113.775 110.663L119.025 121.162L127.93 100.381C128.196 99.7623 128.795 99.3542 129.469 99.3335C130.136 99.3577 130.766 99.6862 131.067 100.288L140.964 120.083H150.271C151.225 120.083 152 120.858 152 121.813C152 122.767 151.225 123.542 150.271 123.542H139.896C139.242 123.542 138.644 123.172 138.35 122.587L129.642 105.171L120.737 125.952C120.47 126.571 119.872 126.979 119.198 127C119.18 127 119.163 127 119.146 127Z",
    fill: "#88C3E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.605 75.9956C125.695 73.6982 123.892 71.8778 121.616 70.9587L121.268 70.8183L121.616 70.6778C123.892 69.7587 125.695 67.9384 126.605 65.641L126.744 65.2899L126.884 65.641C127.794 67.9384 129.597 69.7587 131.873 70.6778L132.22 70.8183L131.873 70.9587C129.597 71.8778 127.794 73.6982 126.884 75.9956L126.744 76.3466L126.605 75.9956Z",
    stroke: "#FB9C0C",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5 94C80.8995 95.513 78.5 98.8497 78.5 103",
    stroke: "#FFC107",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2118_3900"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83,
    height: 83,
    fill: "white",
    transform: "translate(69 44)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyPatients);
export default __webpack_public_path__ + "static/media/EmptyPatients.730fa3548614cc753c62c3c4d1432913.svg";
export { ForwardRef as ReactComponent };